
import { Button } from "@/components/ui/button";
import { Lock, AlertCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { useDealerCredits } from "@/hooks/useDealerCredits";
import { useState, useEffect } from "react";

interface PriceLockButtonProps {
  href?: string;
  onClick?: () => void;
  isHomePage?: boolean;
  dealerId?: string; // Aggiunto per controllare i crediti
}

export function PriceLockButton({ href, onClick, isHomePage = false, dealerId }: PriceLockButtonProps) {
  const { canUsePriceLock, isLoading } = useDealerCredits(dealerId);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    // Se dealerId è presente, controlla i crediti
    if (dealerId) {
      setIsDisabled(!canUsePriceLock && !isLoading);
    }
  }, [dealerId, canUsePriceLock, isLoading]);

  // Se non ci sono crediti sufficienti, mostra bottone disabilitato
  if (dealerId && isDisabled) {
    return (
      <Button 
        variant="outline"
        size="sm"
        className={cn(
          "flex-1 font-medium cursor-not-allowed opacity-60",
          isHomePage && "shadow-md"
        )}
        disabled
        title="Blocca prezzo momentaneamente non attivo per questo compro oro"
      >
        <AlertCircle className="mr-1 h-4 w-4" />
        Non Disponibile
      </Button>
    );
  }

  // Se onClick è fornito, usa un bottone normale con onClick
  if (onClick) {
    return (
      <Button 
        variant="default"
        size="sm"
        className={cn(
          "flex-1 font-medium bg-gold hover:bg-gold-dark",
          isHomePage && "shadow-md"
        )}
        onClick={onClick}
        disabled={isLoading}
      >
        <Lock className="mr-1 h-4 w-4" />
        Blocca Prezzo
      </Button>
    );
  }
  
  // Altrimenti, usa un Link (comportamento di default)
  return (
    <Button 
      variant="default"
      size="sm"
      className={cn(
        "flex-1 font-medium bg-gold hover:bg-gold-dark",
        isHomePage && "shadow-md"
      )}
      asChild
    >
      <Link to={href || "#"}>
        <Lock className="mr-1 h-4 w-4" />
        Blocca Prezzo
      </Link>
    </Button>
  );
}
